import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { clearField } from '@shared/utils/form-field.utils';
import { DoubleDateTableFilter, DoubleNumberInputTableFilter } from '@shared/components/table-filter-menu/table-filter-menu.models';
import { getError } from '@shared/utils/error.utils';
import { SmartFormContainer } from '@shared/classes/smart-form-container';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-double-number-input-filter',
  templateUrl: './double-number-input-filter.component.html',
  styleUrls: ['./double-number-input-filter.component.scss'],
})
export class DoubleNumberInputFilterComponent extends SmartFormContainer implements OnInit {
  readonly getError = getError;
  readonly clearField = clearField;
  @Input() config: DoubleNumberInputTableFilter;
  @Input() sm: boolean = false;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  override ngOnInit(): void {
    // We don't need this because we don't want to
    // get such control { '': null }
    void 0;
  }
}
